import type { HomeBatteryFunnelSettingsInterface } from '@innogy/feh/models';
import type { Action } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';

import {
  clearHomeBatteryFunnelInitializedAction,
  mintHomeBatteryTrackingIdAction,
  setHomeBatteryFunnelInitializedAction,
} from '../actions/homebattery-funnel.actions';

export const homeBatteryFunnelKey = 'homebattery-funnel';

export type HomeBatteryFunnelState = HomeBatteryFunnelSettingsInterface;

export const initialHomeBatteryFunnelState: HomeBatteryFunnelState = {
  id: undefined,
  initialized: false,
  startPage: undefined,
  orderPage: undefined,
  successPage: undefined,
  trackingId: undefined,
};

const reducer = createReducer(
  initialHomeBatteryFunnelState,
  on(setHomeBatteryFunnelInitializedAction, (state, { funnelSettings }) => ({
    ...state,
    ...funnelSettings,
    initialized: true,
  })),
  on(clearHomeBatteryFunnelInitializedAction, (state) => ({
    ...state,
    initialized: false,
  })),
  on(mintHomeBatteryTrackingIdAction, (state, { id: trackingId }) => ({
    ...state,
    trackingId,
  }))
);

export const homeBatteryFunnelReducer = (
  state: HomeBatteryFunnelState = initialHomeBatteryFunnelState,
  action: Action
): HomeBatteryFunnelState => reducer(state, action);
